export enum SuscriptionType {
  KIMBO = 'kimbo',
  BENEFIT = 'benefit',
}

export enum FeatureType {
  KIMBO = 'kimbo',
  BENEFIT = 'benefit',
}

export enum BillingPeriod {
  MONTHLY = 'monthly',
  YEARLY = 'yearly',
}


export enum Plan {
 BASIC = 'basic',
 PREMIUM = 'premium',
 ESSENTIAL = 'essential',
 ENTERPRISE = 'enterprise',
}

export enum UserTrashType {
  WITH = 'with',
  ONLY = 'only',
  WITHOUT = 'without',
}
